module.exports = __webpack_public_path__ + "img/hook quantity.26b3188c.png";